<template>
  <div class="demo-alignment">
    <vs-button :color="color" :type="type" @click="popupActive = true" :class="[btnClass !== '' ? btnClass : '']" icon-pack="feather" icon="icon-file-text" :disabled="disabled || files.length === 0">
      {{ btnText }}
    </vs-button>
    <vs-popup :title="title" :active.sync="popupActive" id="pdf-viewer">
      <vs-tabs v-if="popupActive">
        <vs-tab :label="index === 0 ? file.name : $t('other')" v-for="(file, index) in files" :key="index">
          <div class="tab-text">
            <iframe :src="file.pdf" class="w-full show-pdf" :style="{ height: '70vh' }"></iframe>
          </div>
        </vs-tab>
      </vs-tabs>
    </vs-popup>
  </div>
</template>
<script>
import { BASE_URL } from '@/urls.js'
export default {
  props: {
    title: {
      type: String,
      default: 'Title'
    },
    files: {
      type: Array,
      default: () => []
    },
    color: {
      type: String,
      default: 'primary'
    },
    type: {
      type: String,
      default: 'filled'
    },
    btnText: {
      type: String,
      default: 'Open'
    },
    btnClass: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      popupActive: false
    }
  },
  methods: {
    getName(url) {
      return url.substring(url.lastIndexOf('/') + 1)
    }
  },
  watch:{
    popupActive(val){
      setTimeout(() => {
        this.$store.dispatch('setPopup',val)
      }, 500)
    }
  },
   mounted() {
    document.addEventListener('keyup', (e) => {
      if (e.key === 'Escape') {
         this.popupActive = false
      }
    })
  },
}

</script>
<style>
/* 1366 x 768 */
.show-pdf {
  display: block;
  border: none;
}

#pdf-viewer>div.vs-popup {
  width: calc(100% - 30px) !important;
}

</style>
